import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

interface AlertDialogProps {
  dialogContentComponent?: React.ComponentType<any>
  title: string
  // Accept ReactNode so callers can pass strings (default) or rich JSX
  // (e.g. <strong> highlights) without a separate prop.
  contentText: React.ReactNode
  nameButtonCancel?: string
  nameButtonConfirm?: string
  onButtonClick: () => void
  nameButtonSecondary?: string
  onSecondaryClick?: () => void
  onClose: () => void
  open: boolean
  containedButton?: boolean
}

export const AlertDialog: React.FC<AlertDialogProps> = ({
  dialogContentComponent: DialogContentComponent = () => null,
  title,
  contentText,
  nameButtonCancel = 'Cancel',
  nameButtonConfirm = undefined,
  onButtonClick,
  nameButtonSecondary = undefined,
  onSecondaryClick = undefined,
  onClose,
  open,
  containedButton = false
}: AlertDialogProps): JSX.Element => {
  const handleButtonClick = (): void => {
    onButtonClick()
    onClose()
  }

  const handleSecondaryClick = (): void => {
    onSecondaryClick?.()
    onClose()
  }

  return (
    <>
      <DialogContentComponent />
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{contentText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} autoFocus>{nameButtonCancel}</Button>
          {(nameButtonSecondary != null) && <Button variant={containedButton ? 'outlined' : 'text'} onClick={handleSecondaryClick}>
            {nameButtonSecondary}
          </Button>}
          {(nameButtonConfirm != null) && <Button variant={containedButton ? 'contained' : 'text'} onClick={handleButtonClick} autoFocus>
            {nameButtonConfirm}
          </Button>}
        </DialogActions>
      </Dialog>
    </>
  )
}
